export enum EBOL_STATUS {
    ACCEPTED = 'accepted',
    REJECTED = 'rejected',
    ACCEPTED_WITH_DISCREPANCIES = 'accepted_with_discrepancies',
}